import gql from "graphql-tag";

export const SUBSCRIBE_USEFUL_LINKS = gql`
    subscription ($partnerType:jsonb!, $oemId:[uuid!]){
        UsefulLink(where: {visibleTo: {_contains: $partnerType}, oemId: {_in: $oemId}, isActive:{_eq: true}}, order_by: {sequence: asc}) {
            id
            imageUrl
            redirectUrl
            oemId
            categoryId
        }
    }`
